export namespace ORDER_STATUS_TYPE {
    export const StatusDraft = "draft"
    export const StatusOrdered = "ordered"
    export const StatusCompleted = "completed"
    export const StatusUnnamed = "Unnamed"
}

export type ORDER_STATUS_TYPE = typeof ORDER_STATUS_TYPE[keyof typeof ORDER_STATUS_TYPE]



// WEBPACK FOOTER //
// ./src/order-status/OrderStatusType.ts